// extracted by mini-css-extract-plugin
module.exports = {"form":"AddForm_form__2OGfC","input":"AddForm_input__1hkHC"};